window.copyToClipboard = function(text) {
	const btn = window.event.target.closest('.copy-link-btn');
	const originalTitle = btn.getAttribute('title');
	
	function showFeedback() {
		btn.setAttribute('title', 'Lenke kopiert!');
		btn.style.opacity = '0.7';
		
		setTimeout(() => {
			btn.setAttribute('title', originalTitle);
			btn.style.opacity = '1';
		}, 2000);
	}
	
	if (navigator.clipboard && window.isSecureContext) {
		navigator.clipboard.writeText(text).then(() => {
			showFeedback();
		}).catch(() => {
			fallbackCopy(text);
			showFeedback();
		});
	} else {
		fallbackCopy(text);
		showFeedback();
	}
	
	function fallbackCopy(text) {
		const textArea = document.createElement('textarea');
		textArea.value = text;
		textArea.style.position = 'fixed';
		textArea.style.left = '-999999px';
		textArea.style.top = '-999999px';
		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();
		
		try {
			document.execCommand('copy');
		} catch (err) {
			console.error('Fallback copy failed: ', err);
		}
		
		document.body.removeChild(textArea);
	}
};
